export default {
  defaultStyle: {
    display: 'table-cell',
    paddingRight: '5px',
    verticalAlign: 'middle',
    width: '33.47%',
    textAlign: 'left',
    maxWidth:'400px',
    '&:lang(ar)':{
      direction:'rtl',
      paddingRight:0,
      paddingLeft:'5px',
      textAlign:'right'
    }
  },
  hotelName: {
    display: 'inline',
    lineHeight: '17px',
    color: '#fff',
    marginRight:'3px',
    font:data => '300 18px ' + data.fontFamily2
  },
  hotelStars:{
    display: 'inline',
    lineHeight: '17px',
    color: '#fff',
    font:data => '300 14px ' + data.fontFamily1
  },
  hotelAddress: {
    font:data => '300 13px ' + data.fontFamily1,
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '99.7%',
    color: '#fff'
  },
  flyHotelLink: {
    font:data => '500 13px ' + data.fontFamily1,
    letterSpacing: '.8px',
    display: 'block',
    color: data => data.engineColorFont,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
};
